import { getAllByLicenseCountAsync, getByIdAsync } from '../../index';
import { useMutation } from 'react-query';

export const useDefenseEventByIdAsync = () => useMutation(getByIdAsync);

export const useDefenseEventAllByLicenseCountAsync = () =>
  useMutation(getAllByLicenseCountAsync);
